import { useMemo } from "react";

import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useAccountSwitcherController } from "./AccountSwitcher.controller";
import { AccountSwitcherPresentation } from "./AccountSwitcher.pres";
import {
  buildAccountHeaderLabel,
  buildAccountOptions,
} from "./accountSwitcher.utils";

export const AccountSwitcher = () => {
  const {
    liveAccounts,
    paperAccounts,
    currentAccount,
    setCurrentAccount,
    isLoading,
  } = useAccountContext();

  const options = useMemo(
    () => buildAccountOptions({ liveAccounts, paperAccounts }),
    [liveAccounts, paperAccounts],
  );
  const selectedOption = options.find(
    (option) => option.id === currentAccount?.id,
  );
  const triggerLabel =
    currentAccount && selectedOption
      ? buildAccountHeaderLabel(currentAccount, selectedOption.product)
      : undefined;

  const { presentation } = useAccountSwitcherController({
    value: currentAccount?.id,
    options,
    triggerLabel,
    isLoading,
    onValueChange: setCurrentAccount,
  });

  return <AccountSwitcherPresentation {...presentation} />;
};
